import { useNavigate } from "react-router-dom";
import { relativeURL } from "../relativeURL";

export const useChangePerspective = () => {
  let navigate = useNavigate();
  async function changePerspective(
    species,
    database,
    nativeId,
    network_type,
    protein_type,
    userColor
  ) {
    const resp = await fetch(relativeURL("/api/change_perspective"), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        species: species,
        database: database,
        nativeId: nativeId,
        network_type: network_type,
        protein_type: protein_type,
        user_color: userColor
      }),
    });

    const body = await resp.json();
    navigate(`/session/${body.sid}`);
  }

  return {
    changePerspective,
  };
};
